import HCLDX from "@system/config/hcldx";
import Constants from "src/helper/Constants";
import System from "src/helper/system";

class CheckOut {
    static GET_PAYMENT_METHOD = System.getCartUrl() + '/api/paymentmethod/list';
    static ORDER_VALIDATE = System.getCartUrl() + '/api/order/validateOrder';
    static TAX_EXEMPT_FILE_UPLOAD = System.getUserUrl() + '/api/user/amer/upload/taxExempt';

    static getCheckOutRouteURL() {
        return HCLDX.baseURL() + '/shop/check-out';
    }

    static getCheckOutStatusRouteURL(checkoutFrom = Constants.systemModules.CART) {
        if (checkoutFrom === Constants.systemModules.Quote) {
            return HCLDX.baseURL() + '/shop/quote-order-confirmation';
        }
        return HCLDX.baseURL() + '/shop/order-confirmation';

    }
}

export default CheckOut;